import httpClient from '@/lib/httpClient.js'
import { useQuery } from '@tanstack/react-query'

export default function useGetPrearchiveVault(id) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/vault/${id}/pre-archive`)
    return response.data.data
  }

  return useQuery({
    queryKey: ['prearchive-vault', id],
    queryFn: fetchData,
    enabled: !!id,
  })
}
